document.addEventListener('DOMContentLoaded', function () {
  initializeCarousels();
  observeProductGrid();
  editorialLazyLoad();
  initializeExpandableItems();
});

let currentMode = window.innerWidth < 750 ? 'mobile' : 'desktop';

window.addEventListener('resize', function () {
  const newMode = window.innerWidth < 750 ? 'mobile' : 'desktop';
  
  if (newMode !== currentMode) {
    currentMode = newMode;
    initializeExpandableItems();
  }
});


function initializeCarousels() {
  const carousels = document.querySelectorAll('.column.slider div.container-carousel');
  
  carousels.forEach(function (carouselContainer) {
    if (!carouselContainer.classList.contains('custom-carousel-initial')) {
      new ImageCarousel(carouselContainer);
      carouselContainer.classList.add('custom-carousel-initial');
    }
  });
}

function observeProductGrid() {
  const productGrid = document.querySelector('ul#product-grid');
  if (productGrid) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          initializeCarousels();
        }
      });
    });

    observer.observe(productGrid, {
      childList: true,
      subtree: true 
    });
  }
}

function editorialLazyLoad() {
  if (document.querySelector('body.template-article #main-content .grid__item.animation')) {
    const animateOnScroll = (elements) => {
      gsap.fromTo(
        elements, 
        { scale: 0.9, opacity: 0, filter: "blur(8px)" },
        { 
          scale: 1, 
          opacity: 1, 
          filter: "blur(0px)", 
          stagger: 0.15, 
          ease: window.theme.settings.animation_easing 
        }
      );
    };
  
    const animationObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateOnScroll([entry.target]);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
  
    document.querySelectorAll('body.template-article #main-content .grid__item.animation').forEach(item => {
      animationObserver.observe(item);
    });
  
    const lazyObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target.querySelector("video");
          const img = entry.target.querySelector("img");
  
          if (video && video.dataset.src) {
            video.src = video.dataset.src;
            video.play();
          }
  
          if (img && img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.add('loaded');
          }
  
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
  
    document.querySelectorAll('body.template-article #main-content .grid__item.animation').forEach(item => {
      lazyObserver.observe(item);
    });
  }
}

function initializeExpandableItems() {
  // Elimina cualquier comportamiento inicial
  document.querySelectorAll('.expandableItem').forEach(item => {
    const header = item.querySelector('h4');
    const content = item.querySelector('.answerText');

    if (header && content) {
      header.classList.remove('active');
      content.classList.remove('active');
      content.style.display = 'none';
    }
  });

  // Paso 1: limpiar eventos reemplazando h4
  document.querySelectorAll('.expandableItem h4').forEach(header => {
    const newHeader = header.cloneNode(true);
    header.parentNode.replaceChild(newHeader, header);
  });

  // Paso 2: volver a seleccionar los nuevos h4 y añadir eventos
  document.querySelectorAll('.expandableItem h4').forEach(header => {
    header.addEventListener('click', function () {
      const currentItem = header.parentElement;
      const answer = header.nextElementSibling;
      const isOpen = header.classList.contains('active');

      if (isOpen) {
        // Cerrar si ya está abierto
        header.classList.remove('active');
        answer.classList.remove('active');
        slideUp(answer, 300);
      } else {
        // Cerrar los demás y abrir este
        closeAllExpandableItemsExcept(currentItem);
        header.classList.add('active');
        answer.classList.add('active');
        slideDown(answer, 300);
      }

      setTimeout(() => {
        if (typeof handleScroll === 'function') {
          handleScroll();
        }
      }, 300);
    });
  });
}



function closeAllExpandableItemsExcept(currentItem) {
  const allItems = document.querySelectorAll('.expandableItem');

  allItems.forEach(item => {
    if (item !== currentItem) {
      const h4 = item.querySelector('h4');
      const answer = item.querySelector('.answerText');

      h4.classList.remove('active');
      answer.classList.remove('active');
      slideUp(answer, 300);
    }
  });
}

function slideUp(element, duration = 300) {
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight; // force reflow
  element.style.transition = `height ${duration}ms ease`;
  element.style.overflow = 'hidden';
  element.style.height = '0';

  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}

function slideDown(element, duration = 300) {
  element.style.removeProperty('display'); // reset display first
  let display = window.getComputedStyle(element).display;

  if (display === 'none') {
    display = 'block';
  }

  element.style.display = display;
  const height = element.offsetHeight;
  element.style.height = '0';
  element.style.overflow = 'hidden';
  element.offsetHeight; // force reflow
  element.style.transition = `height ${duration}ms ease`;
  element.style.height = height + 'px';

  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}



class ImageCarousel {
  constructor(carouselContainer) {
    this.carouselContainer = carouselContainer;
    this.images = this.carouselContainer.querySelectorAll('img:not(noscript img)');

    if (this.images.length > 1) {
      this.setCarouselHeight();
      this.init();
    }
  }

  setCarouselHeight() {
    let maxHeight = 0;
    this.images.forEach((img) => {
      const imageHeight = img.offsetHeight;
      if (imageHeight > maxHeight) {
        maxHeight = imageHeight;
      }
    });

    this.carouselContainer.style.height = `${maxHeight}px`;
  }


  init() {
    new Flickity(this.carouselContainer, {
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'center',
      contain: true,
      groupCells: true,
    });


    const prevButton = this.carouselContainer.querySelector('.flickity-prev-next-button.previous');
    const nextButton = this.carouselContainer.querySelector('.flickity-prev-next-button.next');

    if (prevButton) {
      prevButton.innerHTML = `<svg aria-hidden="true" width="11px" height="15px" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
    }

    if (nextButton) {
      nextButton.innerHTML = `<svg aria-hidden="true" focusable="false" width="11px" height="15px" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
    }

    [prevButton, nextButton].forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault(); 
        });
      }
    });
  }
}
